import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { Observable, catchError, map, of } from 'rxjs';
import * as Sentry from '@sentry/angular';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StrapiService {
  public strapiUrl: string = 'https://admin.mototechna.cz';
  private router = inject(Router);
  private http = inject(HttpClient);

  getLandingPage(page: string): Observable<any> {
    return this.http.get<any>(`${environment.strapiLandingpageApi}${page}`, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((e) => {
        Sentry.captureMessage('Nepodařilo se načíst landing page ze strapi: ' + this.router.url + ' - Error: ' + e.message, { level: 'fatal', extra: { page: page } });
        return of(e);
      }),
    );
  }
}
